import { useEffect } from 'react';

export function usePendoVisitorReport(enabled: boolean) {
  useEffect(() => {
    if (enabled) {
      window.trackPendoVisitorReport?.();
    }
  }, [enabled]);
}
